import _extends from "@babel/runtime/helpers/extends";
import { PricingLockup as CorePricingLockup } from '@vds-core/type-lockups';
import React from 'react';
import styled from 'styled-components';
import { TitleConfig, MicroConfig, TypographyConfig } from '@vds/typography';

var PricingLockup = function PricingLockup(props) {
  return /*#__PURE__*/React.createElement(CorePricingLockup, _extends({}, props, {
    padding: true,
    titleConfig: TitleConfig,
    microConfig: MicroConfig,
    typescale: TypographyConfig.getTypescale()
  }));
};

export default PricingLockup;